import { commonFilter } from './filter';

export default {
  pageName: 'DataMapOpinionsMetrics',
  pageId: '20020',
  pagePath: '/opinion/DataMap/OpinionsMetrics',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
